import { Routes } from '@angular/router';
import { loginGuard } from './core/guards/login.guard';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: "",
        loadChildren: () => import('./main/main.routes').then(m => m.MAIN_ROUTES),
        canActivate: [authGuard],
        
    },
    {
        path: "auth",
        loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
        canActivate: [loginGuard]
    },
    {
        path: "**",
        redirectTo: ""
    }
];
